import core from './core';
import store from '@/store/store'
import utils from '@/utils/utils'

export default {
  getChatbotToken(parameters={}) {
    return core.call({
      url: '/api/v1/chatbot/getChatBotToken',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  },
  getChatbotVerify(parameters={}) {
    return core.call({
      url: '/api/v1/chatbot/verify',
      method: 'post',
      data: parameters,
      headers: {
        'Authorization': 'Bearer '+ store.getters.authToken,
        'deviceUuid': utils.nativeCom.getUserAgentValue("deviceUuid")
      }
    });
  }
}
